<template>
  <div class="order-item">
    <div class="order-item-item order-item-quantity">{{ line.quantity }}</div>
    <div class="order-item-item order-item-name">{{ line.description }}</div>
  </div>
</template>

<script>
export default {
  props: ['line']
}
</script>

<style>
  .order-item {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    -webkit-display: flex;
    -webkit-flex-direction: row;
    -webkit-justify-content: flex-start;
    -webkit-align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    height: 40px;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    background-color: #E7E9EF;
    margin: 10px 0;
  }

  .order-item-item {
    color: #7B7C80;
    font-size: 17px;
    font-family: 'Rubik', sans-serif;
  }

  .order-item-quantity {
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-display: flex;
    -webkit-justify-content: center;
    -webkit-align-items: center;
    text-align: center;
    font-weight: 800;
    width: 25px;
    height: 25px;
    margin: 5px;
    color: #7B7C80;
    border-radius: 50%;
    -webkit-border-radius: 50%;
  }

  .order-item-name {
    font-weight: 700;
  }

  @media screen and (max-width: 320px) {
    .order-item {
      height: 35px;
      margin: 5px auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lines/Line.vue